// Therapeutic groups as published on the Sponsors page. Items may contain
// inline HTML (e.g. the Vexillum link), so use stripTags() for plain text.

export const therapeuticGroups = [
  {
    id: "acute-chronic",
    title: "Acute & Chronic Conditions",
    description: "Phases II to IV trials for Adults and Pediatrics subjects",
    items: [
      "Allergy/Immunology",
      "Cardiology",
      "Consumer Health",
      "Decentralized",
      "Dermatology",
      "Diagnostics",
      "Endocrinology/Metabolic Disorders",
      "Family Practice",
      "Vaccine",
      "Gastroenterology",
      "Infectious Disease",
      "Internal Medicine",
      "Medical Devices",
      "Nephrology",
      "Neurology",
      "Obesity",
      "OB-GYN",
      "Urology",
      "Orthopedics, Sports Medicine",
      "Pain Management",
      "Psychiatry",
      "Pulmonary Disease",
      "Respiratory",
      "Rheumatology",
      "Sleep Medicine",
      "Smoking Cessation",
    ],
  },
  {
    id: "vaccines",
    title: "Vaccines",
    description: "Test new candidate vaccines",
    items: [
      "Anthrax",
      "Avian Influenza",
      "Difficile (C-diff)",
      "Celiac Disease",
      "Chikungunya",
      "Cytomegalovirus (CMV)",
      "Dengue fever",
      "Diphtheria",
      "Ebola",
      "Encephalitis",
      "Zoster",
      "Parainfluenza",
      "Pertussis",
      "Plague",
      "Pneumococcal",
      "Rabies",
      "Respiratory syncytial virus (RSV)",
      "SARS-CoV-2 (COVID-19)",
      "Smallpox",
      "Tetanus",
      "Type 3 (PIV3)/RSV combo",
      "West Nile virus",
      "HCMV",
      "Hepatitis B",
      "Herpes",
      "Human papillomavirus (HPV)",
      "Human metapneumovirus (hMPV)",
      "Influenza",
      "Lyme disease",
      "Meningococcal",
      "mRNA vaccines",
      "Norovirus",
      "Zika virus",
    ],
  },
  {
    id: "sample-diagnostic",
    title: "Sample & Diagnostic Trials",
    description: "Collect High-quality biological specimens",
    items: [
      "Via Specific sponsor protocol",
      "Via its sister company, <a href='https://akklinemedia.com/vexillum' target='_blank' rel='noopener noreferrer'>Vexillum</a>",
    ],
    note: "Experts at the complexity, speed, quality and volume of subjects needed to successfully conduct Diagnostic Clinical Trials.",
  },
];

export const stripTags = (html) => html.replace(/<[^>]*>/g, "");
